module.exports = __webpack_public_path__ + "img/天天特卖示例图.4d1fa942.jpeg";